module.exports = __webpack_public_path__ + "img/EducationalCourseLevelQuestions.b49b0aac.svg";